
import {
  Swiper,
  SwiperSlide
} from "vue-awesome-swiper";
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";
import "swiper/css/swiper.css";

export default BaseCmsBlock.extend({
  name: "OurTransportCargoListBlock",

  data: function () {
    return {
      swiperOptions: {
        spaceBetween: 15,
        slidesPerView: 1.1,
        slidesPerGroup: 1,
        autoHeight: true
      },
    }
  },

  computed: {
    title: function () {
      return this.externalData?.OurTransportCargoListBlock?.title
    },
    tags: function () {
      return (this.externalData?.OurTransportCargoListBlock?.list || []).map((t) => t.text)
    },
    list: function () {
      return (this.externalData?.OurTransportCargoListBlock?.list || [])
    },

    isVisible: function () {
      const device = this.$store.state.device?.device;

      const isMobile = Boolean(this.cfgs?.visible_mobile && device?.isMobile);
      const isTablet = Boolean(this.cfgs?.visible_laptop && device?.isTablet);
      const isDesktop = Boolean(this.cfgs?.visible_pc && device?.isDesktop);

      return Boolean(isMobile || isTablet || isDesktop)
    }
  },

  components: {
    Swiper,
    SwiperSlide
  },

  methods: {
    openForm: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          type: 'Заказать звонок',
          hideTabs: true,
        }
      });
    }
  }
})
